import { HttpClient, HttpResponseBase } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LUP_ALINEA_EXTERNAL_URL } from '@loup-transload-ui-app/common-services';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  private readonly http = inject(HttpClient);
  private readonly externalUrl = inject(LUP_ALINEA_EXTERNAL_URL);

  /** POST call start */
  createVendorRegistration(inputData: any) {
    return this.http.post<HttpResponseBase>(
      `${this.externalUrl}transload/create-vendor-registration-request/1.0`,
      inputData
    );
  }
}
